import { render } from "./user-reports-filter.vue?vue&type=template&id=2dc6f97c"
import script from "./user-reports-filter.vue?vue&type=script&lang=js"
export * from "./user-reports-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__